<template>
  <div v-if="!loadingData">
    <element-renderer
      v-for="elementId in childElementsReversed"
      v-show="!getElementById(elementId)?.layerHiddenInGraphics"
      :id="elementId"
      :key="elementId"
      :type="getElementValueByProp(elementId, 'type')"
      :toggle="toggle"
      :parent="id"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions } from 'vuex';

import elementsMixins from '../../../mixins/elements-mixins';
import sportradarMixin from '../../../mixins/sportradar-mixin';
import sportradarModule from '../../../store/modules/sportradar/index';
import toast from '../../../utils/toasts';

export default {
  name: 'SportradarElement',
  inheritAttrs: false,
  components: {
    ElementRenderer: defineAsyncComponent(() => import('../ElementRenderer')),
  },
  mixins: [sportradarMixin, elementsMixins],
  data() {
    return {
      loadingData: false,
    };
  },
  computed: {
    childElements() {
      return this.getElementGroupMap[this.id] || [];
    },

    childElementsReversed() {
      return [...this.childElements]
        .reverse();
    },
  },
  async created() {
    // Setup store module for storing data for this provider
    if (!this.$store.hasModule(this.element.id)) {
      // make backwards compatible and safe with old elements using sport vs leagueName
      const leagueName = this.element.data.leagueName || this.element.data.sport;
      if (sportradarModule[leagueName]) {
        await this.$store.registerModule(this.element.id, sportradarModule[leagueName]);
        this.$store.commit(`${[this.element.id]}/SET_ID`, this.element.id);
        // Resync
        this.sync();
      } else {
        // eslint-disable-next-line no-console
        console.warn(`Sportsradar Store Module for ${leagueName} not found.`);
        toast.makeToast({
          heading: 'Error',
          icon: 'error',
          text: 'We ran into an issue creating this element. Please close the modal and try again later.',
        });
      }
    }
  },
  methods: {
    ...mapActions({
      syncDataFromElement(dispatch, payload) {
        return dispatch(`${this.element.id}/syncDataFromElement`, payload);
      },
    }),

    async sync() {
      // make backwards compatible and safe with old elements using sport vs leagueName
      this.element.data.sport = this.element.data.leagueName || this.element.data.sport;
      if (!this.element.data.sport) return;

      this.loadingData = true;
      try {
        await this.syncDataFromElement(this.element.data);
      } catch (error) {
        console.error('Error syncing data', error);
      }
      this.loadingData = false;
    },
  },
};
</script>
